import { persistMarketPreference } from '../utils/market-preference';

export default class LanguageSelector extends HTMLElement {
  private form: HTMLFormElement | null = null;
  private languageSelect: HTMLSelectElement | null = null;
  private countryInput: HTMLInputElement | null = null;

  private onLanguageChangeBound = this.onLanguageChange.bind(this);

  connectedCallback(): void {
    this.form = this.querySelector('form');
    this.languageSelect = this.querySelector('select[name="language_code"]');
    this.countryInput = this.querySelector('input[name="country_code"]');

    this.addEventListeners();
  }

  addEventListeners(): void {
    this.languageSelect?.addEventListener('change', this.onLanguageChangeBound);
  }

  removeEventListeners(): void {
    this.languageSelect?.removeEventListener('change', this.onLanguageChangeBound);
  }

  private onLanguageChange(): void {
    persistMarketPreference(this.countryInput?.value, this.languageSelect?.value);
    this.form?.requestSubmit();
  }

  disconnectedCallback(): void {
    this.removeEventListeners();
  }
}

customElements.define('language-selector', LanguageSelector);
